import { Component, ErrorInfo, ReactNode } from 'react';
import { Button, Result } from 'antd';

interface Props {
  children: ReactNode;
  title?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

/**
 * Глобальный перехватчик ошибок React.
 * Ловит JS-исключения в дочерних компонентах и
 * показывает понятный UI вместо белого экрана.
 */
class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo);
  }

  private handleReload = () => {
    window.location.reload();
  };

  private handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/admin/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title={this.props.title || 'Что-то пошло не так'}
          subTitle={<div><div>{this.state.error?.message || 'Произошла ошибка при загрузке раздела'}</div><pre style={{fontSize:10,maxHeight:300,overflow:'auto',textAlign:'left',background:'#f5f5f5',padding:8,marginTop:8,whiteSpace:'pre-wrap'}}>{this.state.error?.stack}</pre></div>}
          extra={[
            <Button type="primary" key="reload" onClick={this.handleReload}>
              Перезагрузить страницу
            </Button>,
            <Button key="home" onClick={this.handleGoHome}>
              На главную
            </Button>,
          ]}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
